import type { TokenGroup } from './grouped-tokens';

/**
 * A reducer that finds how many tokens are in a collection of groups 🥲 very silly
 */
export const getNumberOfTokensInGroups: (groups: TokenGroup[]) => number = (groups: TokenGroup[]) =>
	groups.reduce((count, group) => {
		const topLevel = group.tokens.length;

		const topLevelExtensions = group.tokens.reduce((extensionCount, token) => {
			const inExtensions = token.extensions ? token.extensions.length : 0;

			return extensionCount + inExtensions;
		}, 0);

		const inSubgroups = group.subgroups
			? group.subgroups.reduce((subgroupCount, subgroup) => {
					const subgroupExtensions = subgroup.tokens.reduce((extensionCount, token) => {
						const inExtensions = token.extensions ? token.extensions.length : 0;

						return extensionCount + inExtensions;
					}, 0);

					return subgroupCount + subgroup.tokens.length + subgroupExtensions;
				}, 0)
			: 0;

		return count + topLevel + topLevelExtensions + inSubgroups;
	}, 0);
